// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { FeedGetString, FeedGetStringAsync } from './types.generated'

const feedLocales = ['en-US'] as const
const feedBundle = i18nBundle('blackbolt/feed', feedLocales)

export const getString: FeedGetString = feedBundle.getString
export const getStringAsync: FeedGetStringAsync = feedBundle.getStringAsync
